import type { AxiosApiResponsePromise } from "~/api/apiResponseTypes.ts";
import axiosApi from "~/api/axiosApi.ts";
import type {
	CreateQuotaData,
	Quota,
	QuotaWithRelations,
	UpdateQuotaInvoicingDetailsData,
} from "~/modules/client/api/quota/quotaTypes.ts";

const clientsQuotaBaseEndpoint = (clientId: string) => `clients/${clientId}/quotas`;
const clientsQuotaDetailsEndpoint = (clientId: string,
	quotaId: string) => `${clientsQuotaBaseEndpoint(clientId)}/${quotaId}`;

export function showQuota(clientId: string,
	quotaId: string,
	withRelations?: boolean): AxiosApiResponsePromise<Quota | QuotaWithRelations> {
	const params = withRelations ? { withRelations: true } : undefined;
	return axiosApi.get(clientsQuotaDetailsEndpoint(clientId, quotaId), { params });
}

export function indexQuotasByClientId(clientId: string): AxiosApiResponsePromise<QuotaWithRelations[]> {
	return axiosApi.get(clientsQuotaBaseEndpoint(clientId));
}

export function createQuota(clientId: string, data: CreateQuotaData): AxiosApiResponsePromise<Quota> {
	return axiosApi.post(clientsQuotaBaseEndpoint(clientId), { ...data });
}

export function updateQuotaInvoicingDetails(clientId: string,
	quotaId: string,
	invoicingDetails: UpdateQuotaInvoicingDetailsData): AxiosApiResponsePromise<void> {
	return axiosApi.patch(clientsQuotaDetailsEndpoint(clientId, quotaId) + "/invoicing-details", invoicingDetails);
}

export function updateQuotaStatus(clientId: string,
	quotaId: string,
	isBookable: boolean): AxiosApiResponsePromise<void> {
	return axiosApi.patch(clientsQuotaDetailsEndpoint(clientId, quotaId) + "/status", { isBookable });
}

export function updateQuotaTitle(clientId: string, quotaId: string, title: string): AxiosApiResponsePromise<void> {
	return axiosApi.patch(clientsQuotaDetailsEndpoint(clientId, quotaId) + "/title", { title });
}

export function deleteQuota(clientId: string, quotaId: string): AxiosApiResponsePromise<void> {
	return axiosApi.delete(clientsQuotaDetailsEndpoint(clientId, quotaId));
}

export function addProjectPhasesToQuota(clientId: string,
	quotaId: string,
	projectPhaseIds: string[]): AxiosApiResponsePromise<void> {
	return axiosApi.patch(clientsQuotaDetailsEndpoint(clientId, quotaId) + "/phases", { projectPhaseIds });
}

export function removePhaseFromQuota(clientId: string,
	quotaId: string,
	phaseId: string): AxiosApiResponsePromise<void> {
	return axiosApi.delete(clientsQuotaDetailsEndpoint(clientId, quotaId) + `/phases/${phaseId}`);
}
